import { CreditCard, ShieldCheck } from 'lucide-react'
import React from 'react'
const cards = [
  {
    title: "Pay After Homepage Delivery",
    desc: "First, test and verify our work with a developed homepage. If satisfied, continue the project afterward.",
    highlight: "GST registration required",
    icon: <ShieldCheck size={28} className="text-orange-500 " />,
  
  },
  {
    title: "Pay Only Domain Charges",
    desc: "Start your project by paying only domain charges. You can also proceed using guarantee cheque for additional trust and security.",
    icon: <CreditCard size={28} className="text-orange-500 " />,
   
  }
];
function TruestSection() {
  return (
 <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-white dark:bg-[#050505] transition-all duration-300">

      {/* BG GLOW */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-primary/10 blur-[120px] rounded-full"></div>

      <div className="absolute bottom-0 right-0 w-[400px] h-[400px]bg-primary/10 blur-[120px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 
      bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] 
      dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] 
      bg-[size:70px_70px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
           {/* TOP */}
        <div className="text-center mb-14">

          <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full 
          border border-primary/20 bg-primary/10 text-primary text-sm font-semibold backdrop-blur-xl">

            Online Bussinss Trust Issues

          </span>

          <h2 className="mt-6 text-4xl md:text-6xl font-black text-gray-900 dark:text-white">
  How You Can Trust On
       
      

            <span className="block bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">

          Web X Secure  

            </span>

          </h2>

            <p className="mt-4 max-w-2xl mb-12 mx-auto text-gray-600 dark:text-gray-400">
            Transparent, secure, and result-oriented workflows to ensure your project's success.
          </p>

<div className="flex flex-wrap gap-6">
  {cards.map((card, index) => (
    <div key={index} className="flex-1 min-w-[320px] text-left bg-white dark:bg-zinc-900 rounded-xl p-8 border border-gray-200 dark:border-zinc-800">
      <div className="flex gap-5 items-start">
        <div className={`w-14 h-14  `}>
          {card.icon}
        </div>
        <div>
          <h3 className="text-lg font-bold mb-3 text-black dark:text-white">{card.title}</h3>
          <p className="text-gray-600 dark:text-gray-300 leading-7">
            {card.desc}
           
          </p>
        </div>
      </div>
    </div>
  ))}
</div>

        </div>
      </div>
      </section>
  )
}

export default TruestSection
